import config from '@ers/config';
import BaseClient from './BaseClient';

class ApiClient extends BaseClient {
    constructor() {
        super(config.urls.apiRoot);
    }
}
export default ApiClient;